import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext, useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import slugify from 'slugify';
import styled from 'styled-components';
import useSWR from 'swr';
import { ManagedTokenIntegrationConfigs } from '../../../../../../../typings/Integration.interface';
import { APITeam, APITeamWithRole } from '../../../../../../../typings/Team.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import HookdeckAPIClient from '../../../../client/Hookdeck';
import field_formats from '../../../../utils/field-formatters';
import Button, { ClickableArea } from '../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../common/base/Card';
import Container from '../../../common/base/Container';
import Icon from '../../../common/base/Icon';
import Loading from '../../../common/base/Loading';
import Text from '../../../common/base/Text';
import CopyableField from '../../../common/CopyableField';
import Dropdown from '../../../common/Dropdown';
import TextInput from '../../../common/Form/Fields/TextInput';
import { Div } from '../../../common/helpers/StyledUtils';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useSearchQuery from '../../../hooks/useSearchQuery';
import FullscreenLayout from '../../../layouts/FullscreenLayout';
import resource_details_form_props from '../Connections/Forms/resource_details';
import { DashboardContext } from '../DashboardContext';
import TeamSelectionList from '../Nav/TeamSelection/TeamSelectionList';
import NewOrganizationModal from '../Nav/TeamSelection/NewOrganization';
import NewTeamModal from '../Nav/TeamSelection/NewTeam';
import OnboardingNav from '../Onboarding/OnboardingNav';
const StyledCircleIcon = styled(Div)`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid ${({
  theme
}) => theme.colors.outline.neutral};
  box-shadow: ${({
  theme
}) => theme.elevation[1]};
  display: flex;
  align-items: center;
  justify-content: center;
`;
interface FormValues {
  name: string;
  team_id: string;
}
const ConnectView: React.FC = () => {
  const $ = _c(73);
  const {
    HookdeckAPI,
    setAPITeamId,
    configs
  } = useContext(GlobalContext);
  const {
    team
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const {
    query
  } = useSearchQuery();
  const match = useRouteMatch();
  const history = useHistory();
  const initial_team = team && team.type !== "outpost" ? team : null;
  const [selected_team, setSelectedTeam] = useState(initial_team);
  const [modal, setModal] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.teams.listAll();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.teams) {
    t1 = () => HookdeckAPI.teams.listAll();
    $[1] = HookdeckAPI.teams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: teams,
    mutate: mutate_teams,
    isValidating: loading_teams
  } = useSWR(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = APIMethodKeys.organizations.listAll();
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.organizations) {
    t3 = () => HookdeckAPI.organizations.listAll();
    $[4] = HookdeckAPI.organizations;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: organizations,
    mutate: mutate_organizations,
    isValidating: loading_organizations
  } = useSWR(t2, t3);
  let t4;
  if ($[6] !== teams) {
    t4 = teams?.filter(_temp);
    $[6] = teams;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const event_gateway_teams = t4;
  const loading = loading_teams || loading_organizations;
  let t5;
  let t6;
  if ($[8] !== event_gateway_teams || $[9] !== query.team_id) {
    t5 = () => {
      if (query.team_id && event_gateway_teams) {
        const matched = event_gateway_teams.find(t_0 => t_0.id === query.team_id);
        if (matched) {
          setSelectedTeam(matched);
        }
      }
    };
    t6 = [query.team_id, event_gateway_teams];
    $[8] = event_gateway_teams;
    $[9] = query.team_id;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[12] !== match.params.source_id || $[13] !== query.team_id || $[14] !== setAPITeamId) {
    t7 = () => {
      if (match.params.source_id && query.team_id) {
        setAPITeamId(query.team_id);
      }
    };
    t8 = [match.params.source_id, query.team_id, setAPITeamId];
    $[12] = match.params.source_id;
    $[13] = query.team_id;
    $[14] = setAPITeamId;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  useEffect(t7, t8);
  const source_team_id = query.team_id || selected_team?.id || HookdeckAPI.team_id;
  let t9;
  if ($[17] !== configs.API_URL || $[18] !== source_team_id) {
    t9 = new HookdeckAPIClient(configs.API_URL, source_team_id);
    $[17] = configs.API_URL;
    $[18] = source_team_id;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const team_api = t9;
  let t10;
  if ($[20] !== match.params.source_id || $[21] !== source_team_id) {
    t10 = match.params.source_id && source_team_id ? [APIMethodKeys.sources.get(match.params.source_id, {
      include: "config.auth"
    }), source_team_id] : null;
    $[20] = match.params.source_id;
    $[21] = source_team_id;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== match.params.source_id || $[24] !== team_api.sources) {
    t11 = () => team_api.sources.get(match.params.source_id, {
      include: "config.auth"
    });
    $[23] = match.params.source_id;
    $[24] = team_api.sources;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const {
    data: source
  } = useSWR(t10, t11);
  let t12;
  if ($[26] !== event_gateway_teams || $[27] !== selected_team || $[28] !== source_team_id) {
    t12 = selected_team || (source_team_id ? event_gateway_teams?.find(t_1 => t_1.id === source_team_id) : null);
    $[26] = event_gateway_teams;
    $[27] = selected_team;
    $[28] = source_team_id;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const display_team = t12;
  let t13;
  if ($[30] !== addToast || $[31] !== mutate_organizations || $[32] !== mutate_teams) {
    t13 = async created_team => {
      await Promise.all([mutate_organizations(), mutate_teams()]);
      setSelectedTeam(created_team);
      setModal(null);
      addToast("success", `Project ${created_team.name} created and selected`);
    };
    $[30] = addToast;
    $[31] = mutate_organizations;
    $[32] = mutate_teams;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const handle_team_created = t13;
  let t14;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = (picked_team, toggle) => {
      setSelectedTeam(picked_team);
      toggle(false);
    };
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const handle_team_select = t14;
  let t15;
  if ($[35] !== configs.API_URL || $[36] !== history || $[37] !== query.provider || $[38] !== setAPITeamId) {
    t15 = values => {
      const submit_team_api = new HookdeckAPIClient(configs.API_URL, values.team_id);
      submit_team_api.sources.create({
        name: values.name,
        type: "MANAGED",
        config: {}
      }).then(created_source => {
        setAPITeamId(values.team_id);
        const params = new URLSearchParams();
        params.set("team_id", values.team_id);
        if (query.provider) {
          params.set("provider", query.provider);
        }
        history.push(`/connect/${created_source.id}?${params.toString()}`);
      });
    };
    $[35] = configs.API_URL;
    $[36] = history;
    $[37] = query.provider;
    $[38] = setAPITeamId;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  const onSubmit = t15;
  let t16;
  if ($[40] !== query.provider) {
    t16 = query.provider ? slugify(query.provider) : "";
    $[40] = query.provider;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const t17 = selected_team?.id || "";
  let t18;
  if ($[42] !== t16 || $[43] !== t17) {
    t18 = {
      name: t16,
      team_id: t17
    };
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  const initial_values = t18;
  let t19;
  if ($[45] !== handle_team_created || $[46] !== modal?.type) {
    t19 = modal?.type === "organization" && <NewOrganizationModal onClose={() => setModal(null)} onSuccess={handle_team_created} />;
    $[45] = handle_team_created;
    $[46] = modal?.type;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== handle_team_created || $[49] !== modal) {
    t20 = modal?.type === "project" && modal.organization_id && <NewTeamModal organization_id={modal.organization_id} onClose={() => setModal(null)} onSuccess={handle_team_created} />;
    $[48] = handle_team_created;
    $[49] = modal;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <OnboardingNav />;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      justify: "center",
      align: "center",
      direction: "column"
    };
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== configs.API_URL || $[54] !== match.params.source_id) {
    t23 = async values_0 => {
      const errors = {};
      if (!match.params.source_id && !values_0.team_id) {
        errors.team_id = "Please select a project";
      }
      if (!match.params.source_id && values_0.team_id) {
        const validate_team_api = new HookdeckAPIClient(configs.API_URL, values_0.team_id);
        const name_errors = await resource_details_form_props.validate(values_0, name => validate_team_api.sources.nameIsUsed(name), false);
        Object.assign(errors, name_errors);
      }
      return errors;
    };
    $[53] = configs.API_URL;
    $[54] = match.params.source_id;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== display_team || $[57] !== event_gateway_teams || $[58] !== loading || $[59] !== organizations || $[60] !== query.provider || $[61] !== selected_team || $[62] !== source) {
    t24 = props => <Form><StyledCard raised={true} overflow_hidden={true}><StyledCardSection p={3}><Div flex={{
            align: "center",
            justify: "center",
            gap: 4
          }} m={{
            t: 6,
            b: 4
          }}><StyledCircleIcon><Icon icon="source" /></StyledCircleIcon><Icon icon="swap" /><StyledCircleIcon><svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.1604 5.1431C15.2682 5.1431 15.3761 5.22707 15.4301 5.33903C15.484 5.45099 15.457 5.59094 15.3761 5.67491L8.63376 12.6724C6.77287 14.6037 3.72531 14.6037 1.86442 12.6724C0.00352657 10.7411 0.00352657 7.57821 1.86442 5.64692L5.74802 1.61638C6.85377 0.468799 8.36406 0.020962 9.79344 0.216891C9.90132 0.244881 9.98223 0.300859 10.0362 0.412819C10.0631 0.524778 10.0362 0.636739 9.95526 0.720709L9.09224 1.61638C8.95739 1.75633 8.79558 1.8403 8.63376 1.86829C7.98649 1.98025 7.3662 2.28814 6.88074 2.79195L2.99714 6.82249C1.75654 8.11002 1.75654 10.2093 2.99714 11.4968C4.23773 12.7843 6.26044 12.7843 7.50104 11.4968L12.3286 6.48661L11.5465 5.67491C11.4656 5.59094 11.4386 5.45099 11.4925 5.33903C11.5465 5.22707 11.6543 5.1431 11.7622 5.1431H15.1604ZM8.20225 9.20163C8.31013 9.20163 8.418 9.11766 8.47194 9.0057C8.52588 8.89374 8.49891 8.75379 8.418 8.66982L7.63589 7.85812L12.4634 2.84793C13.704 1.5604 15.7267 1.5604 16.9673 2.84793C18.2079 4.13547 18.2079 6.23471 16.9673 7.52224L13.0568 11.5528C12.5713 12.0566 11.951 12.3645 11.3037 12.4764C11.115 12.5044 10.9531 12.5884 10.8453 12.7283L9.98223 13.624C9.90133 13.708 9.87435 13.8199 9.90132 13.9319C9.92829 14.0439 10.0362 14.1278 10.1441 14.1278C11.5734 14.3238 13.0837 13.8759 14.1895 12.7283L18.0731 8.69781C19.934 6.76651 19.934 3.60366 18.0731 1.67236C16.2122 -0.258937 13.1646 -0.258937 11.3037 1.67236L4.56137 8.66982C4.48046 8.75379 4.45349 8.89374 4.50743 9.0057C4.56137 9.11766 4.66925 9.20163 4.77712 9.20163H8.20225Z" fill="#0044CC" /></svg></StyledCircleIcon></Div><Text bold={true} size="l" center={true}>Create {query.provider ? query.provider : "Managed"} Source</Text>{source ? <><Text size="m" muted={true} m={{
              b: 4
            }} center={true}>Provide this token to{" "}{query.provider ? query.provider : "the event producer"} to authenticate it</Text>{display_team && <Button outline={true} large={true} block={true} m={{
              b: 4
            }} style={{
              justifyContent: "flex-start",
              pointerEvents: "none"
            }}><Text ellipsis={true}><Icon icon="folder" left={true} />{display_team.name}</Text></Button>}<Text size="xs" semi={true} muted={true} m={{
              b: 1
            }}>Source Token</Text><CopyableField value={(source.config?.auth as ManagedTokenIntegrationConfigs)?.token} secret={true} reveal_on_hover={false} /></> : loading ? <Div m={{
            t: 4,
            b: 4
          }}><Loading /></Div> : <><Text size="m" muted={true} m={{
              b: 4
            }} center={true}>Confirm the project this source will be created in.</Text><Div m={{
              b: 4
            }}><Dropdown block={true} outline={true} placement="bottom-start" renderToggle={(opened, toggle_0) => <Button outline={true} large={true} block={true} onClick={() => toggle_0(!opened)} style={{
                justifyContent: "space-between"
              }}><Text ellipsis={true} muted={!selected_team} danger={props.submitCount > 0 && !!props.errors.team_id}>{selected_team && <Icon icon="folder" left={true} />}{selected_team?.name || "Select a project..."}</Text><Icon icon="expand_all" muted={!selected_team} /></Button>}>{toggle_1 => <TeamSelectionList organizations={organizations} teams={event_gateway_teams} selected_team_id={selected_team?.id} onTeamSelect={picked_team_0 => {
                  handle_team_select(picked_team_0, toggle_1);
                  props.setFieldValue("team_id", picked_team_0.id);
                }} footer={organizations && organizations.length > 0 ? t25 => {
                  const {
                    focused_organization_id
                  } = t25;
                  return {
                    organizations: <StyledCardSection m={{
                      t: "auto"
                    }} p={1}><ClickableArea onClick={() => setModal({
                        type: "organization"
                      })} p={{
                        y: 1.5,
                        x: 2
                      }} rounded={true} flex={{
                        align: "center"
                      }}><Icon icon="add_circle" muted={true} left={true} pointer={true} /><Text>Create organization</Text></ClickableArea></StyledCardSection>,
                    teams: focused_organization_id ? <StyledCardSection m={{
                      t: "auto"
                    }} p={1}><ClickableArea onClick={() => setModal({
                        type: "project",
                        organization_id: focused_organization_id
                      })} p={{
                        y: 1.5,
                        x: 2
                      }} rounded={true} flex={{
                        align: "center"
                      }}><Icon icon="add_circle" muted={true} left={true} pointer={true} /><Text>New project</Text></ClickableArea></StyledCardSection> : null
                  };
                } : undefined} />}</Dropdown>{props.submitCount > 0 && props.errors.team_id && <Text m={{
                t: 1,
                b: 0
              }} size="s" as="p" danger={true}><Icon icon="info" left={1} />{props.errors.team_id}</Text>}</Div><Text size="m" muted={true} m={{
              b: 4
            }} center={true}>{query.provider ? `${query.provider} will have permission to:` : "The event producer will have permission to:"}</Text><StyledCard m={{
              b: 4
            }}><StyledCardSection flex={{
                gap: 2,
                align: "center"
              }} p={3}><Icon icon="events" /><Text size="m">Send events to this source.</Text></StyledCardSection><StyledCardSection flex={{
                gap: 2,
                align: "center"
              }} p={3}><Icon icon="settings" /><Text size="m">Retrieve and update this source configuration.</Text></StyledCardSection><StyledCardSection flex={{
                gap: 2,
                align: "center"
              }} p={3}><Icon icon="search" /><Text size="m">{"Fetch requests & events for this source."}</Text></StyledCardSection></StyledCard><TextInput name="name" label="Source Name" format={field_formats.slugify} required={true} m={{
              b: 0
            }} /></>}</StyledCardSection><StyledCardSection flex={{
          justify: "flex-end",
          gap: 3
        }} p={3}>{source ? <Button to={`/connections/new?source_id=${source.id}`}>Create connection</Button> : <Button primary={true} submit={true} disabled={loading}>Allow</Button>}</StyledCardSection></StyledCard></Form>;
    $[56] = display_team;
    $[57] = event_gateway_teams;
    $[58] = loading;
    $[59] = organizations;
    $[60] = query.provider;
    $[61] = selected_team;
    $[62] = source;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== initial_values || $[65] !== onSubmit || $[66] !== t23 || $[67] !== t24) {
    t25 = <FullscreenLayout center={true}>{t21}<Container small={true} stretch={true} flex={t22}><Formik initialValues={initial_values} enableReinitialize={true} validate={t23} onSubmit={onSubmit}>{t24}</Formik></Container></FullscreenLayout>;
    $[64] = initial_values;
    $[65] = onSubmit;
    $[66] = t23;
    $[67] = t24;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== t19 || $[70] !== t20 || $[71] !== t25) {
    t26 = <>{t19}{t20}{t25}</>;
    $[69] = t19;
    $[70] = t20;
    $[71] = t25;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  return t26;
};
export default ConnectView;
function _temp(t) {
  return t.type !== "outpost";
}